import { Link } from 'react-router-dom';

const references = [
  {
    project: 'Villa Terası',
    type: 'Bioklimatik Pergola',
    location: 'Alaçatı',
    year: '2024',
    img: '/images/references/home-ref-4.webp',
  },
  {
    project: 'Restoran Terası',
    type: 'Kasetli Tente',
    location: 'Çeşme',
    year: '2024',
    img: '/images/references/home-ref-1.webp',
  },
  {
    project: 'Kafe Bahçesi',
    type: 'Zip Perde',
    location: 'Ilıca',
    year: '2023',
    img: '/images/references/home-ref-3.webp',
  },
  {
    project: 'Yazlık Ev',
    type: 'Şeffaf Branda',
    location: 'Ovacık',
    year: '2023',
    img: '/images/references/home-ref-2.webp',
  },
  {
    project: 'Otel Havuz Başı',
    type: 'Rollingroof Pergola',
    location: 'Dalyan',
    year: '2024',
    img: '/images/references/home-ref-5.webp',
  },
  {
    project: 'Butik Otel',
    type: 'Otomatik Pergola',
    location: 'Reisdere',
    year: '2023',
    img: '/images/references/home-ref-6.webp',
  },
];

export default function ReferencesSection() {
  return (
    <section className="py-24 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="w-8 h-px bg-[#D4A853]"></span>
              <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Tamamlanan Projeler</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#111827] leading-tight">
              Uygulamalarımız ve<br />Referanslarımız
            </h2>
          </div>
          <Link
            to="/referanslar"
            className="flex items-center gap-2 border-2 border-[#111827] text-[#111827] hover:bg-[#111827] hover:text-white font-bold text-xs tracking-widest uppercase px-6 py-3 transition-all whitespace-nowrap cursor-pointer self-start md:self-auto"
          >
            Tüm Referanslar
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {references.map((ref, i) => (
            <div
              key={ref.project}
              className="group relative overflow-hidden cursor-pointer"
              style={{ height: i === 0 ? '360px' : '260px' }}
            >
              <img
                src={ref.img}
                srcSet={`${ref.img.replace('.webp', '-480.webp')} 480w, ${ref.img} 1200w`}
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                alt={`${ref.project} — ${ref.type} — ${ref.location}`}
                width={1200}
                height={896}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111827]/90 via-[#111827]/20 to-transparent"></div>

              {/* Tags */}
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="bg-[#D4A853] text-[#111827] text-xs font-bold px-3 py-1 tracking-wider uppercase">{ref.type}</span>
              </div>

              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-black text-base">{ref.project}</h3>
                <div className="flex items-center justify-between mt-1">
                  <p className="text-white/50 text-xs flex items-center gap-1">
                    <i className="ri-map-pin-line text-[#D4A853]"></i>
                    {ref.location}
                  </p>
                  <span className="text-white/30 text-xs">{ref.year}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
